module.exports = __webpack_public_path__ + "static/img/123.644d20f3.jpg";